module.exports = __webpack_public_path__ + "static/media/02_avatar_male.b162a4fc.png";